/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_UpInputs */

const cs_gallery_up = /** @type {(inputs: Gallery_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahoru`)
};

const en_gallery_up = /** @type {(inputs: Gallery_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Up`)
};

/**
* | output |
* | --- |
* | "Up" |
*
* @param {Gallery_UpInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_up = /** @type {((inputs?: Gallery_UpInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_UpInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_up(inputs)
	return cs_gallery_up(inputs)
});